<template>
    <div class="modal fade" id="viewPrintModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printLoan">
              <!-- right column -->
                <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <!-- <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> -->
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" width="20%"><barcode v-bind:value="seeRecord.member.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <div>
                      <table class="table table-condensed" style="border-width:2px;">
                        <thead style="border-width:2px">
                          <th colspan="2" style="border-width:2px">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right" style="border-width:2px">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody style="border-width:2px">
                          <tr style="border-width:2px">
                            <td width="20%" style="border-width:2px"><strong>Customer Name </strong></td>
                            <td style="border-width:2px"> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td style="border-width:2px"><strong>Contact No : </strong>{{seeRecord.member.mobile}}</td>
                            <td rowspan="3"  style="border-width:2px; text-align:right;">
                              <div class="pull-right" style="border-width:3px;border-style:solid;width:110px;height:120px;text-align:center;"><br>Customer Photo <br>with Cross Sign</div>
                            </td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>DOB :</strong> {{memberDetail.dob | myDate}}</td>
                            <td style="border-width:2px"><strong> Gender : </strong>{{memberDetail.gender}}</td><td style="border-width:2px"></td>
                          </tr>
                          <tr v-if="memberDetail.spouseName">
                            <td style="border-width:2px"><strong>Spouse Name  </strong></td><td style="border-width:2px"> {{memberDetail.spouseName}}</td><td style="border-width:2px"></td>
                          </tr>
                          <tr v-else>
                            <td style="border-width:2px"><strong>C/O </strong></td><td style="border-width:2px"> {{memberDetail.fatherName}}</td><td style="border-width:2px"></td>
                          </tr>
                          <tr>
                            <td style="border-width:2px" colspan="2"><strong>Address Details</strong></td>
                            <td style="border-width:2px" colspan="2"></td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{memberDetail.address}}, {{memberDetail.area}}</td>
                            <td style="border-width:2px"><strong>District/State/Pincode </strong></td><td style="border-width:2px" v-if="memberDetail.state"> {{memberDetail.district}}, {{memberDetail.state.name}} - {{memberDetail.pin}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px" colspan="2"><strong>Bank Details</strong></td>
                            <td style="border-width:2px" colspan="2"><strong>Applied Loan Details</strong></td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px"><strong>Bank : </strong> <span v-if="memberDetail.bank"> {{memberDetail.bank.name}}</span> </td>
                            <td style="border-width:2px"><strong>Branch : </strong><span v-if="memberDetail.bankBranch"> {{memberDetail.bankBranch}}</span></td>
                            <td style="border-width:2px"><strong>Loan ID :</strong> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span> </td>
                            <td style="border-width:2px"><strong>Plan Name :</strong> {{pl.name}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px"><strong>Account Holder : </strong>{{memberDetail.accountHolderName}}</td>
                            <td style="border-width:2px"><strong>Account Number : </strong> <span v-if="memberDetail.accountNumber">{{memberDetail.accountNumber}}</span></td>
                            <td style="border-width:2px"><strong v-if="pl.rateOfInterest > 0">Interest Rate (%) : {{pl.rateOfInterest}} </strong></td>
                            <!-- <td style="border-width:2px"><strong>Interest Rate (%) :</strong> 19.9 </td> -->
                            <td style="border-width:2px"> <strong>GST Include : </strong>{{pl.includeGst}}</td>
                            <!-- <td style="border-width:2px">Insurance Charge </td><td style="border-width:2px" v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td style="border-width:2px" v-else> {{pl.fileCharge}}</td> -->
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px"><strong>IFSC : </strong>{{memberDetail.ifsc}}</td>
                            <td style="border-width:2px"></td>
                            <td style="border-width:2px"><strong>Plan Amount :</strong> {{ planAmt(seeRecord) }}</td>
                            <td style="border-width:2px"><strong>File Charge : </strong>{{ fileChargeFee(seeRecord) }}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px" colspan="2"><strong>Income Details</strong></td>
                            <td style="border-width:2px"><strong>Processing Fee :</strong> {{ processingFee(seeRecord) }}</td>
                            <td style="border-width:2px"><strong>Insurance Fee :</strong> {{ insuranceFee(seeRecord) }}</td>
                          </tr>
                          <tr v-if="pl.rateOfInterest" style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px"><strong>Income (INR) : </strong>{{memberDetail.incomeAmount}}</td>
                            <td style="border-width:2px"><strong>Occupation : </strong>{{memberDetail.jobType}}</td>
                            <td style="border-width:2px"><strong>Recovery type :</strong> {{pl.recoveryType}}</td>
                            <td style="border-width:2px"><strong>Amount to be Paid :</strong> <span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                            
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px"><strong>Business Name : </strong>{{memberDetail.businessName}}</td>
                            <td style="border-width:2px"><strong>Income Type : </strong>{{memberDetail.incomeType}}</td>
                            <td style="border-width:2px"><strong>No of Payments : </strong> <span v-if="pl.noOfPayments">{{pl.noOfPayments}}</span></td>
                            <td style="border-width:2px"> </td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>Minimum Income : </strong>{{memberDetail.minAmount}}</td>
                            <td style="border-width:2px"> </td>
                            <td style="border-width:2px"><strong>Purpose : </strong><span v-if="seeRecord.purpose">{{seeRecord.purpose.purpose}}</span></td>
                            <td style="border-width:2px"><strong>Description : </strong>{{seeRecord.description}}</td>
                          </tr>
                        <!-- </tbody>
                      </table>

                      <table class="table table-condensed" style="border-width:2px">
                        <tbody style="border-width:3px"> -->
                          <tr style="border-width:2px">
                            <td style="border-width:2px" colspan="3"><strong>Guarantor Details</strong></td>
                            <td style="border-width:2px" rowspan="3">
                              <div style="border-width:3px;border-style:solid;width:110px;height:120px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                            </td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px"><strong>Name </strong></td><td style="border-width:2px"> {{memberDetail.guarantorName}}</td>
                            <td style="border-width:2px"><strong>Contact Number : </strong>{{memberDetail.guarantorPhone}} </td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{memberDetail.guarantorAddress}}</td>
                            <td style="border-width:2px"><strong>Narration : </strong>{{memberDetail.guarantorNarration}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>Nominee Details</strong> </td>
                            <td style="border-width:2px"><strong>Nominee Name : </strong>{{memberDetail.nomineeName}}</td>
                            <td style="border-width:2px"><strong>Contact Number : </strong>{{memberDetail.nomineePhone}}</td>
                            <td style="border-width:2px"><strong>Nominee Dob : </strong>{{memberDetail.nomineeDob}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <br><br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br>
                      <p style="page-break-before: always;"></p>
                      <p>1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे</p>
                      <p>2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।</p>
                      <p>3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।</p>
                      <p>4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।</p>
                      <p>5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे</p>
                      
                      <p>6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी</p>
                      <p>7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे</p>
                      <p>8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !</p>
                      <p>9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|</p>
                      <p>10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा</p>
                      <p>11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | </p>
                      <p>12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | </p>
                      <p>13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | </p>
                      <p>14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | </p>
                      <p>15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | </p>
                      <p style="page-break-before: always;"></p>
                      <p>1. All the above parties agree on all the following terms and condition that the borrower will use this amount as
                        per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree
                        that if the company finds any reason to explain which has not been complied with, the company has the right to
                        withdraw this loan amount or part thereof without any Will withdraw the concession.</p>
                      <p>2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against
                        us in any court nor any FIR is registered in any police station.</p>
                      <p>3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor
                        have I/we been declared a defaulter from any financial institution, bank or finance company.</p>
                      <p>4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the
                        payment under any circumstances</p>
                      <p>5. That whichever employee of the company will come to collect the instalment amount, I will keep polite
                        behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any
                        way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is
                        done by us then company will be free to take legal action against us.</p>
                      <p>6. That I/We the company will not be responsible for giving notices, reminders and electronic information
                        phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,
                        the entire responsibility related to this will be my / ours.</p>
                      <p>7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email
                        Id, they shall give prior written notice to the company.</p>
                      <p>8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by
                        us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the
                        loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the
                        right to take legal action against us.</p>
                      <p>9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service
                        charge required for providing the calling, email notice.</p>
                      <p>10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or
                        insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.</p>
                      <p>11. That all the information given by me/us to the company has been provided orally which is the true and
                        correct in which no false fact of any kind have been told , if any information is found to be false then the
                        company has the right to take legal action against us. I will keep all the information about the loan, Such as the
                        amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete
                        information by the company employee, we are fully prepared for all the above terms and condition and if
                        me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which
                        will come in future will be provided by us.</p>
                      <p>12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,
                        Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in
                        future, if any document is found to be forged, we can be sued for 420 by the company, which we are already
                        aware of.</p>
                      <p>13. That me/we want to pay our instalments monthly.</p>
                      <p>14. That I/we shall be present in time as and when called for by the company for the payment of this loan and
                        acceptance of the arrears or any part thereof or for any other specified purpose. </p>
                      <p>15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said
                        agreement or loan, we are doing this agreement in full consciousness.</p>
                      <br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br><br><br><br><br>

                      </div>
                      <div v-if="seeRecord.status == 'pending'">
                        <br><br>
                        <table class="table">
                          <thead>
                            <th>Application Date</th>
                            <th>Customer</th>
                            <th>Account Number</th>
                            <th>Guarantor Name</th>
                            <th>Plan Amount</th>
                            <th>Amount to be Paid</th>
                            <th v-show="pl.planType === 'normal'">No. of EMI</th>
                          </thead>
                          <tbody>
                            <td>{{seeRecord.disbursementDate | myDate}}</td>
                            <td>{{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td>{{memberDetail.accountNumber}}</td>
                            <td>{{memberDetail.guarantorName}}</td>
                            <td>{{ planAmt(seeRecord) }}</td>
                            <td><span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                            <td v-show="pl.planType === 'normal'">{{pl.noOfPayments}}</td>
                          </tbody>
                        </table>
                        <br><br>
                        <table class="table" v-if="seeRecord.status == 'pending'">
                          <thead>
                            <th>Branch Manager Signature</th>
                            <th>Customer Signature</th>
                            <th>Date</th>
                          </thead>
                        </table>
                        <br><br>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
// import jsPDF from 'jspdf'
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  methods: {
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    fileChargeFee (row) {
      var fcamt
      var pln = JSON.parse(row.plan)
      fcamt = row.fileCharge ? row.fileCharge : pln.fileCharge
      if (pln.includeGst === 'true') {
        return fcamt + fcamt * 18 / 100
      } else {
        return fcamt
      }
    },
    processingFee (row) {
      var pfamt
      var pln = JSON.parse(row.plan)
      if (pln.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (pln.processingFee * row.loanAmount / 100) : (pln.processingFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
      if (pln.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : pln.processingFee
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
    },
    insuranceFee (row) {
      var ifamt
      var pln = JSON.parse(row.plan)
      if (pln.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (pln.insuranceFee * row.loanAmount / 100) : (pln.insuranceFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
      if (pln.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : pln.insuranceFee
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount + this.seeRecord.fileCharge + this.seeRecord.processingFee
      } else {
        return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      }
    },
    print () {
      // Get HTML to print from element
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // var doc = new jsPDF()
      const prtHtml = document.getElementById('printLoan').innerHTML
      // doc.text(10,10,html)
      // doc.save('output.pdf')
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>
<style scoped>
  @media print {
      div { 
        /* float: none !important; */
        /* position: static !important;  */
        display: inline; 
        /* box-sizing: content-box !important; */
      }
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .content {
    padding: 0px;
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// ViewLoan.vue?7447e6b9